<template>
  <header class="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-8 shrink-0">
    <button class="lg:hidden p-2" @click="$emit('toggle-menu')">
      <span class="material-symbols-outlined">menu</span>
    </button>
    <!-- BUSINESS SWITCHER -->

    <div class="business-switcher" ref="bizSwitcher">

      <div class="switcher-trigger"  v-if="ldata!=null && ldata.user_type!=='admin'" @click="toggleDropdown">

        <div class="w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center">
          <span class="text-[10px] font-bold text-orange-600">{{ initials }}</span>
        </div>

        <span class="text-sm font-semibold text-slate-700">
          {{ businessName }}
        </span>

        <span class="material-symbols-outlined text-slate-400 text-sm">
          expand_more
        </span>
      </div>

      <!-- DROPDOWN -->
      <div v-if="showDropdown" class="switcher-dropdown">

        <div v-for="biz in businesses" :key="biz.buss_id" @click="selectBusiness(biz)" class="dropdown-item">
          <div class="avatar-mini">
            {{ biz.buss_title!=null?biz.buss_title.charAt(0).toUpperCase():"A" }}
          </div>

          <span>{{ biz.buss_title }}</span>
        </div>

      </div>
    </div>


    <div class="flex items-center gap-4 header-quick-actions">

      <button @click="gotocmap('/campaign/new')" class="quick-action-btn blue" v-if="ldata!=null && ldata.user_type!=='admin'" 
        style="display: flex; align-items: center;">
        <span class="material-symbols-outlined">campaign</span>
        &nbsp;&nbsp;
        New Reviews Campaign
      </button>

      <button @click="gotocmap('/campaign/ref/new')" class="quick-action-btn yellow" v-if="ldata!=null && ldata.user_type!=='admin'"
        style="display: flex; align-items: center; margin-left: .6rem;">
        <span class="material-symbols-outlined">add_link</span>
        &nbsp;&nbsp;
        New Refferal Campaign 
      </button>

      <button v-if="ldata!=null && ldata.user_type!=='admin'"  @click="gotonoti()" style="margin-left: 1rem;" class="p-2 text-slate-500 hover:bg-slate-50 rounded-full">
        <span class="material-symbols-outlined">notifications</span>
      </button>
      <button v-if="ldata==null || ldata.user_type==='admin' || checkIfMobile()"></button>

      <div class="flex items-center gap-3">

        <div class="text-right">
          <p class="text-sm font-bold text-slate-800">{{ user.name }}</p>
          <p class="text-xs text-slate-500">{{ user.role }}</p>
        </div>

        <div class="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
          <span class="material-symbols-outlined text-white text-[20px]">
            person
          </span>
        </div>

      </div>
    </div>
  </header>
</template>
<script>
import { getUdt,chkReview } from "@/apis/userapis";
  export default {
    data() {
      return {
        ldata:null,
        businesses:[],
        userSet:null,
        planDt:null,
        showDropdown: false,
        isMobile:false,

        businessName: '********',

        // businesses: [
        //   { id: 1, name: 'The Artisan Bakery', initials: 'AB' },
        //   { id: 2, name: 'Urban Dental Studio', initials: 'UD' },
        //   { id: 3, name: 'Glow Beauty Clinic', initials: 'GB' }
        // ],

        user: {
          name: '*********',
          role: '****'
        },

        notifications: 3
      }
    },
    mounted() {
      const tmp = sessionStorage.getItem("ldata")||"";
      if(tmp && tmp.length>0){
        this.isLoggedIn = true;
        this.ldata = JSON.parse(tmp);
        if(this.ldata!=null){
          this.user.name = this.ldata.user_name;
          this.user.role = this.ldata.user_type==="admin"?"Admin":"Owner";
        }
        this.getUdtNow();
        this.chkReviewNow();
      }
      document.addEventListener("click", this.handleClickOutside);
  },

    beforeUnmount() {
      document.removeEventListener("click", this.handleClickOutside);
    }
    ,
    computed: {
      initials() {
        return this.businessName
          .split(' ')
          .map(word => word[0])
          .join('')
          .substring(0, 2)
          .toUpperCase()
      }
    },
    methods: {
      gotocmap(path){
        window.location.href = path;
      },
      async getUdtNow() {
        try {
          const res = await getUdt(
            this.ldata.user_id,
          );

          if (!res.status) {
            return;
          }

          // ✅ UPDATE SESSION DATA
          this.ldata = res.user;
          this.businesses = res.bussnesses;
        
          if(this.businesses.length<=0){
            // alert(this.$route.path+"");
            if (this.$route.path === '/settings') {
              console.log('You are on settings');
            }
            else{
              window.location.href = "/settings?typ=bussniesses";
            }
        }
          this.userSet = res.userSet;
          this.planDt = res.planDt;
          if(this.businesses!=null && this.businesses.length>0){
           
           const savedBuss = sessionStorage.getItem("myBuss");
          
            if (!this.businesses || this.businesses.length === 0) {
              this.businessName = "No Business";
              sessionStorage.removeItem("myBuss");
              return;
            }

            if (!savedBuss || savedBuss==="undefined") {

              const firstBusiness = this.businesses[0];

              this.businessName = firstBusiness.buss_title;

              sessionStorage.setItem("myBuss", JSON.stringify(firstBusiness));

            } else {

              const parsed = JSON.parse(savedBuss);

              // ✅ Validate saved business still exists
              const exists = this.businesses.find(
                b => b.buss_id == parsed.buss_id
              );

              if (!exists) {

                const firstBusiness = this.businesses[0];

                this.businessName = firstBusiness.buss_title;

                sessionStorage.setItem("myBuss", JSON.stringify(firstBusiness));

              } else {

                this.businessName = exists.buss_title;

              }
            }
          }
        } catch (error) {
          console.error(error);
        }
      },
      async chkReviewNow() {
        try {
         await chkReview(
            this.ldata.user_id,
          );

         
        
        } catch (error) {
          console.error(error);
        }
      },
      
      checkIfMobile() {
        this.isMobile = window.innerWidth <= 768;
      },
      toggleDropdown() {
        this.showDropdown = !this.showDropdown;
      },

      selectBusiness(biz) {
        this.businessName = biz.buss_title;
        sessionStorage.setItem("myBuss",JSON.stringify(biz));
        this.showDropdown = false;
      },

      handleClickOutside(e) {
        if (!this.$refs.bizSwitcher.contains(e.target)) {
          this.showDropdown = false;
        }
      },

      gotonoti() {
        window.location.href = "/notifications";
      }
    }
  }
</script>
<style scoped>
  /* ================= HEADER MOBILE PATCH ================= */

  @media (max-width: 1024px) {

    header {
      padding-left: 1rem !important;
      padding-right: 1rem !important;
    }

    /* Stack header content */
    header {
      flex-wrap: wrap;
      height: auto !important;
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
      gap: 0.75rem;
    }

    /* Business selector full width */
    header>div:first-child {
      width: 100%;
    }

    /* Right section alignment */
    header>div:last-child {
      width: 100%;
      justify-content: space-between;
    }

    /* Reduce avatar size */
    header .w-10 {
      width: 2.2rem;
      height: 2.2rem;
    }
  }


  /* ================= SMALL MOBILE ================= */

  @media (max-width: 640px) {

    /* Compact typography */
    header p.text-sm {
      font-size: 0.8rem;
    }

    header p.text-xs {
      font-size: 0.65rem;
    }

    /* Button scaling */
    header button {
      padding: 0.4rem !important;
    }
  }

  /* ================= HEADER MOBILE FIX (SINGLE ROW) ================= */

  @media (max-width: 1024px) {

    header {
      padding-left: 1rem !important;
      padding-right: 1rem !important;

      /* FORCE SINGLE ROW */
      flex-wrap: nowrap !important;
      height: 56px !important;
      gap: 6px;
    }

    /* Business selector shrink */
    header>div:nth-child(2) {
      flex: 1;
      min-width: 0;
    }

    /* Prevent text overflow */
    header>div:nth-child(2) span.text-sm {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 140px;
      display: block;
    }

    /* Right section tighter */
    header>div:last-child {
      gap: 6px;
    }

    /* Hide role text (optional but recommended) */
    header p.text-xs {
      display: none;
    }

    /* Reduce avatar */
    header .w-10 {
      width: 2.2rem;
      height: 2.2rem;
    }

    /* Compact buttons */
    header button {
      padding: 0.35rem !important;
    }
  }


  /* ================= SMALL MOBILE ================= */

  @media (max-width: 640px) {

    header {
      height: 52px !important;
    }

    header p.text-sm {
      font-size: 0.78rem;
    }

    header>div:nth-child(2) span.text-sm {
      max-width: 100px;
    }
  }

  .business-switcher {
    position: relative;
  }

  .switcher-trigger {
    display: flex;
    align-items: center;
    gap: 8px;

    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 6px 10px;
    border-radius: 10px;

    cursor: pointer;
    transition: 0.15s;
  }

  .switcher-trigger:hover {
    background: #f1f5f9;
  }

  .switcher-dropdown {
    position: absolute;
    top: 110%;
    left: 0;

    width: 240px;
    background: white;

    border-radius: 14px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);

    padding: 6px;
    z-index: 100;

    animation: dropdownEnter 0.12s ease;
  }

  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;

    padding: 8px 10px;
    border-radius: 10px;

    font-size: 13px;
    font-weight: 500;
    cursor: pointer;

    transition: 0.12s;
  }

  .dropdown-item:hover {
    background: #f8fafc;
  }

  .avatar-mini {
    width: 26px;
    height: 26px;
    border-radius: 8px;

    background: #197fe6;
    color: white;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 10px;
    font-weight: 700;

    flex-shrink: 0;
  }

  @keyframes dropdownEnter {
    from {
      opacity: 0;
      transform: translateY(4px);
    }

    to {
      opacity: 1;
      transform: none;
    }
  }

  .header-quick-actions {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .quick-action-btn {
    height: 34px;
    padding: 0 14px;

    border-radius: 10px;
    border: none;

    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.2px;

    cursor: pointer;
    transition: 0.18s ease;

    white-space: nowrap;
  }

  .quick-action-btn.blue {
    background: linear-gradient(135deg, #197fe6, #0f6fd6);
    color: white;
    box-shadow: 0 6px 16px rgba(25, 127, 230, 0.35);
  }

  .quick-action-btn.blue:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(25, 127, 230, 0.45);
  }

  .quick-action-btn.yellow {
    background: linear-gradient(135deg, #f59e0b, #fbbf24);
    color: white;
    box-shadow: 0 6px 16px rgba(245, 158, 11, 0.35);
  }

  .quick-action-btn.yellow:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(245, 158, 11, 0.45);
  }

  @media (max-width: 640px) {

    .quick-action-btn {
      height: 30px;
      padding: 0 10px;
      font-size: 11px;
      border-radius: 8px;
    }
  }
  
</style>